<div
  class="app-shell"
  [class.is-collapsed]="sidebarCollapsed"
  [class.is-mobile]="isMobile"
  [class.is-overlay-open]="sidebarOpen"
>
  <app-sidebar
    [collapsed]="sidebarCollapsed"
    [mobileOpen]="sidebarOpen"
    (itemSelect)="closeSidebar()"
  ></app-sidebar>

  <button
    type="button"
    class="sidebar-overlay"
    (click)="closeSidebar()"
    [attr.aria-hidden]="!sidebarOpen"
  ></button>

  <div class="app-main">
    <app-topbar (toggleSidebar)="toggleSidebar()"></app-topbar>

    <main class="content">
      <router-outlet></router-outlet>
    </main>

    <app-footer></app-footer>
  </div>
</div>
